import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-998e2d4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "slides-counter"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "image-name" }
const _hoisted_4 = ["src"]

import {computed, onMounted, onUnmounted, PropType, ref, watch} from "vue";
import ScrollableElement from "@/lib/components/flexible/ScrollableElement.vue";
import {CarouselShortcut} from "@/lib/components/frame/carousel/type/CarouselShortcut";
import ShortcutsManager from "@/lib/common/helpers/ShortcutsManager";
import {CarouselShortcutType} from "@/lib/components/frame/carousel/enum/CarouselShortcutType";
import {SImageData} from "@/lib/store/model/media/SImageData";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'CarouselControlsBar',
  props: {
  images: Array as PropType<SImageData[]>,
  selectedImage: Object as PropType<SImageData>,
  shortcuts: Array as PropType<CarouselShortcut[]>
},
  emits: ["onImageSelected"],
  setup(__props, { emit: emits }) {

const props = __props






const selectImage = (image: SImageData) => {
  if (image.instanceId !== props.selectedImage?.instanceId)
    emits("onImageSelected", image);
};

// ------------------------------
//  Slides counter
// ------------------------------

const currentSlideId = computed(() => {
  return props.selectedImage && props.images ? (props.images.findIndex(image => image.instanceId === props.selectedImage?.instanceId) + 1) : "-";
})

// ------------------------------
//  Scroll
// ------------------------------

const controlBar = ref(),
    scrollable = ref();

const centerDiv = (div: HTMLElement) => {
  scrollable.value.scrollable.scrollTo({
    left: div.offsetLeft - (controlBar.value.offsetWidth / 2),
    top: 0,
    behavior: "smooth"
  });
}

// ------------------------------
//  Shortcuts handling
// ------------------------------

const carouselControlBarSlideSelectors = ref();

onMounted(() =>
{
  if (props.shortcuts)
  {
    props.shortcuts.forEach((shortcut: CarouselShortcut) =>
    {
      ShortcutsManager.register(shortcut.keyCode, shortcut.requiresCtrl as boolean, shortcut.requiresAlt as boolean, shortcut.requiresShift as boolean,  () =>
      {
        if (carouselControlBarSlideSelectors.value)
        {
          const slides = carouselControlBarSlideSelectors.value.filter((element: HTMLElement) => element),
              currentSlideKeyArray = Object.keys(slides).filter((slideKey: any) => slides[slideKey].classList.contains("selected"));

          if (
              slides.length
              && carouselControlBarSlideSelectors.value
          )
          {
            const currentSlideKey: number|undefined = currentSlideKeyArray.length ? +currentSlideKeyArray[0] : undefined;

            let targetSlide;

            switch (shortcut.type)
            {
              case CarouselShortcutType.TO_PREVIOUS_SLIDE:
                if (typeof currentSlideKey === "undefined")
                  targetSlide = slides[0];
                else if (currentSlideKey !== 0)
                  targetSlide = slides[currentSlideKey - 1];
                break;

              case CarouselShortcutType.TO_NEXT_SLIDE:
                if (typeof currentSlideKey === "undefined")
                  targetSlide = slides[0];
                else if (currentSlideKey !== (slides.length - 1))
                  targetSlide = slides[currentSlideKey + 1];
                break;

              case CarouselShortcutType.TO_FIRST_SLIDE:
                targetSlide = slides[0];
                break;

              case CarouselShortcutType.TO_LAST_SLIDE:
                targetSlide = slides[slides.length - 1];
                break;
            }

            if (targetSlide)
            {
              targetSlide.click();

              centerDiv(targetSlide);
            }
          }
        }
      });
    })
  }
})

onUnmounted(() => {
  ShortcutsManager.unregisterAll();
})

// ------------------------------
//  Images load bug fix
// ------------------------------

const forceReload = ref(false);

watch(() => props.images, () => {
  forceReload.value = true;

  setTimeout(() => {
    forceReload.value = false;
  }, 100);
})


return (_ctx: any,_cache: any) => {
  return (!forceReload.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "control-bar",
        ref_key: "controlBar",
        ref: controlBar
      }, [
        (__props.images && __props.images.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(currentSlideId)) + " / " + _toDisplayString(__props.images.length), 1))
          : _createCommentVNode("", true),
        _createVNode(ScrollableElement, {
          "is-horizontal-scroll": true,
          ref_key: "scrollable",
          ref: scrollable
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image.instanceId,
                class: _normalizeClass('slide-selector ' + ((__props.selectedImage && __props.selectedImage.instanceId === image.instanceId) ? 'selected' : '')),
                ref_for: true,
                ref_key: "carouselControlBarSlideSelectors",
                ref: carouselControlBarSlideSelectors,
                onClick: ($event: any) => (selectImage(image))
              }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(image.name), 1),
                _createElementVNode("img", {
                  src: image.url,
                  alt: "click to select this image to annotate"
                }, null, 8, _hoisted_4)
              ], 10, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 512)
      ], 512))
    : _createCommentVNode("", true)
}
}

})